import React from 'react'
import useScreenSizes from 'src/stories/hooks/useScreenSizes'
import { WarningIcon } from 'src/stories/assets'
import styled from 'styled-components'
import { Body } from 'src/stories/typography'

const StyledCard = styled.div<{ isDesktop: boolean }>(
  ({ theme, isDesktop }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: isDesktop ? 'row' : 'column',
    alignItems: 'center',
    columnGap: theme.space(4),
    rowGap: theme.space(2),
    backgroundColor: theme.colors.base_0,
    border: `2px solid ${theme.colors.warning_70}`,
    borderRadius: theme.constants.largeBorderRadius,
    padding: `${theme.space(3)} ${theme.space(5)}`,
    boxShadow: `
      ${theme.colors.base_20}
      ${theme.space(0)}
      ${theme.space(0)}
      ${theme.space(4)}
      ${theme.space(0)}
    `,
  })
)

const StyledWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.space(3),
}))

const StyledWarningIcon = styled(WarningIcon)(({ theme }) => ({
  minWidth: theme.space(6),
}))

export interface WarningCardProps extends React.PropsWithChildren {
  content?: string
}

const WarningCard: React.FCWithChildren<WarningCardProps> = ({
  content,
  children,
}) => {
  const { isSmallScreen } = useScreenSizes()

  return (
    <StyledCard isDesktop={isSmallScreen}>
      <StyledWrapper>
        <StyledWarningIcon />
        <Body size="large" color="darker">
          {content}
        </Body>
      </StyledWrapper>
      {children}
    </StyledCard>
  )
}

export default WarningCard
